import { render, staticRenderFns } from "./CategoryMenuChild.vue?vue&type=template&id=d3289d04&scoped=true&"
import script from "./CategoryMenuChild.vue?vue&type=script&lang=js&"
export * from "./CategoryMenuChild.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMenuChild.vue?vue&type=style&index=0&id=d3289d04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3289d04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListGroup,VListItemIcon,VListItemTitle})
